<div>
  <ng-template asyncInsertionPoint></ng-template>
</div>
